import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { FINDCLINIC_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API лендинга пациента: публичный справочник площадок, инвайты, мои клиники.
 */
export const findclinicApi = createApi({
  reducerPath: "findclinicApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["PublicClinics", "MyClinics", "ClinicInvite"],
  endpoints: (builder) => ({
    getPublicClinics: builder.query({
      query: ({ q } = {}) => ({
        url: FINDCLINIC_ENDPOINTS.PUBLIC_CLINICS,
        method: "GET",
        params: q ? { q } : {},
      }),
      providesTags: [{ type: "PublicClinics", id: "LIST" }],
    }),

    postFunnel: builder.mutation({
      query: (body) => ({
        url: FINDCLINIC_ENDPOINTS.PUBLIC_FUNNEL,
        method: "POST",
        data: body,
      }),
    }),

    getPublicInvite: builder.query({
      query: (code) => ({
        url: FINDCLINIC_ENDPOINTS.PUBLIC_INVITE(code),
        method: "GET",
      }),
    }),

    getMyClinics: builder.query({
      query: () => ({ url: FINDCLINIC_ENDPOINTS.MY_CLINICS, method: "GET" }),
      providesTags: [{ type: "MyClinics", id: "LIST" }],
    }),

    requestClinic: builder.mutation({
      query: (body) => ({
        url: FINDCLINIC_ENDPOINTS.MY_CLINICS,
        method: "POST",
        data: body,
      }),
      invalidatesTags: [{ type: "MyClinics", id: "LIST" }],
    }),

    getClinicInvites: builder.query({
      query: ({ site } = {}) => ({
        url: FINDCLINIC_ENDPOINTS.INVITES,
        method: "GET",
        params: site ? { site } : {},
      }),
      providesTags: [{ type: "ClinicInvite", id: "LIST" }],
    }),

    createClinicInvite: builder.mutation({
      query: (body) => ({
        url: FINDCLINIC_ENDPOINTS.INVITES,
        method: "POST",
        data: body,
      }),
      invalidatesTags: [{ type: "ClinicInvite", id: "LIST" }],
    }),

    revokeClinicInvite: builder.mutation({
      query: (id) => ({
        url: FINDCLINIC_ENDPOINTS.INVITE_REVOKE(id),
        method: "POST",
      }),
      invalidatesTags: [{ type: "ClinicInvite", id: "LIST" }],
    }),
  }),
});

export const {
  useGetPublicClinicsQuery,
  useLazyGetPublicClinicsQuery,
  usePostFunnelMutation,
  useLazyGetPublicInviteQuery,
  useGetMyClinicsQuery,
  useRequestClinicMutation,
  useGetClinicInvitesQuery,
  useCreateClinicInviteMutation,
  useRevokeClinicInviteMutation,
} = findclinicApi;

export default findclinicApi;
